module.exports = new __parcel__URL__("error.5fbc7fe9.png").toString();